import { Chip } from '@coolblue-development/freddy';
import { GraduationCap } from '@coolblue-development/icons';
import { Education, EducationLevel } from '@sharedTypes';

type Props = {
  educationLevels: Education[];
};

export const EducationChip = ({ educationLevels }: Props) => {
  if (
    educationLevels.length === 0 ||
    educationLevels.some(level => level.id === EducationLevel.None)
  ) {
    return null;
  }
  return (
    <Chip startIcon={<GraduationCap />}>
      {educationLevels.map(level => level.displayName).join(' / ')}
    </Chip>
  );
};
